import {Link} from "react-router-dom";
import styled from "styled-components";
import {ws} from "styles/tokens";

export const StyleLink = styled(Link).attrs((props) => ({
  to: props.to,
  target: props.target || "_self"
}))`
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  float: ${(props) => props.float};
  font-size: ${(props) => props.fontSize};
  line-height: ${(props) => props.lineHeight};
  letter-spacing: ${(props) => props.letterSpacing};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  border-color: ${(props) => props.borderColor};
  color: ${(props) => props.color || ws.accentText};
  cursor: ${(props) => props.cursor};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  z-index: ${(props) => props.zIndex};
  &:hover {
    text-decoration: none;
    color: ${(props) => props.color || ws.accentDeep};
  }
  &:visited {
    text-decoration: none;
    color: ${(props) => props.color || ws.accentText};
  }
`;
